angular.module('ikeweb.user').controller('BillingController', [
    '$scope',
    'billingService',
    '$rootScope',
    'events',
    '$location',
    '$stateParams',
    'promiseFactory',
    '$timeout',
    'pubSubService',
    'userTopics',
    'subscriptionActionService',
    function($scope,
        billingService,
        $rootScope,
        events,
        $location,
        $stateParams,
        promiseFactory,
        $timeout,
        pubSubService,
        userTopics,
        subscriptionActionService) {
        $scope.noCard = true;
        $scope.showError = false;
        $scope.errorMessage = '';
        $scope.showSuccess = false;
        $scope.successMessage = '';
        $scope.loading = true;
        $scope.canTrial = false;

        this.subscriptionWillEnd = function() {
            var subscription = $scope.subscription;
            return (subscription != null && subscription.cancel_at_period_end);
        };

        function openPurchaseModal() {
            if ($scope.canTrial) {
                $scope.openPurchaseTrialModal();
            } else {
                $scope.openPurchasePremiumModal();
            }
            $location.url($location.path());
        }

        function startUpgrade() {
            if (!$scope.subscription && $stateParams.upgrade === true) {
                openPurchaseModal();
            }

            //Watch for future changes and act accordingly.
            $scope.$watch(function() {
                return $location.search();
            }, function(newValue, oldValue) {
                if (newValue.upgrade === true && oldValue.upgrade === undefined && !$scope.subscription) {
                    openPurchaseModal();

                }
            });
        }

        function updateCard() {
            return billingService.getCurrentCreditCard()
                .then(function(creditCard) {
                    $scope.noCard = !creditCard;
                    $scope.currentCard = creditCard;
                });
        }

        function updateTrialDaysRemaining() {
            return billingService.getTrialDaysRemaining().then(function(days) {
                $scope.trialDaysRemaining = days;
            });
        }

        function updateActiveSubscription() {
            return billingService.getActiveSubscription().then(function(subscription) {
                $scope.subscription = subscription;
            });
        }

        function updateUpcomingInvoice() {
            return billingService.getUpcomingInvoice().then(function(invoice) {
                $scope.upcomingInvoice = invoice;
            });
        }

        function updateInvoices() {
            return billingService.getInvoices().then(function(invoices) {
                $scope.invoices = invoices;
            });
        }

        function canTrial() {
            return subscriptionActionService.canTrial().then(function(trial) {
                $scope.canTrial = trial;
            });
        }

        $scope.cancelSubscription = function(subscription) {
            return billingService.cancelSubscription(subscription)
                .then(function() {
                    $rootScope.$broadcast(events.SUBSCRIPTION.CANCELED, subscription);
                });
        };

        $scope.cancelSubscriptionTrial = function(subscription) {
            return billingService.cancelSubscriptionTrial(subscription)
                .then(function() {
                    $rootScope.$broadcast(events.SUBSCRIPTION.CANCELED, subscription);
                });
        };

        $scope.openUpdateCard = function() {
            $scope.$broadcast('DISPLAY_UPDATE_CARD');
        };
        $scope.openPurchaseTrialModal = function() {
            $scope.$broadcast(events.BILLING.PURCHASE_TRIAL.DISPLAY);
        };

        $scope.openPurchasePremiumModal = function() {
            $scope.$broadcast(events.BILLING.PURCHASE_PREMIUM.DISPLAY);
        };

        $scope.hasUpcomingInvoice = function() {
            return ($scope.upcomingInvoice !== undefined && $scope.currentCard !== undefined);
        };

        $scope.hasInvoiceHistory = function() {
            var invoices = $scope.invoices || [];
            return (invoices.filter(function(invoice) {
                return invoice.total > 0;
            }).length > 0);
        };

        $scope.hasBillingDetails = function() {
            return ($scope.hasUpcomingInvoice() || $scope.hasInvoiceHistory());
        };

        function updateSubscriptionState() {
            return promiseFactory.all([
                updateActiveSubscription(),
                updateUpcomingInvoice(),
                updateInvoices(),
                updateTrialDaysRemaining(),
                updateCard(),
                canTrial()
            ]);
        }

        // Register for events
        pubSubService.subscribe(userTopics.CREDITCARD.UPDATED, updateSubscriptionState);
        $scope.$on('$destroy', function() {
            pubSubService.unsubscribe(userTopics.CREDITCARD.UPDATED, updateSubscriptionState);
        });

        Object.keys(events.SUBSCRIPTION).forEach(function(event) {
            $scope.$on(events.SUBSCRIPTION[event], updateSubscriptionState);
        });

        updateSubscriptionState().then(function() {
            $timeout(startUpgrade);
            $scope.loading = false;
        });
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/billing.controller.js
// module id = 154
// module chunks = 0